import { useEffect } from 'react';
import { Table } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from '../../../../../../services/clientService';
import { getTableColumns } from './constants';
import { fetchAssets } from '../../../../../../reducers/Assets/actions';

export const MyAssetsTable = () => {
  const dispatch = useDispatch();
  const { assets, isFetchingAssets } = useSelector(
    ({ AssetsReducer }) => AssetsReducer,
  );
  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  const pagination = {
    position: ['bottomRight'],
    defaultPageSize: 10,
  };

  useEffect(() => {
    dispatch(fetchAssets());
  }, []);

  return (
    <Table
      rowKey="address"
      loading={isFetchingAssets}
      columns={getTableColumns()}
      dataSource={assets}
      scroll={tableScroll}
      pagination={pagination}
    />
  );
};
